import React from 'react';
import PropTypes from 'prop-types';
import NavLink from './NavLink';
import NavOldLink from './NavOldLink';
import NavButton from './NavButton';

const PortalNav = ({ children }) => (
  <div id="user-nav" className="navbar">
    <ul className="nav btn-group">{children}</ul>
  </div>
);

PortalNav.displayName = 'PortalNav';

PortalNav.propTypes = {
  children: PropTypes.node.isRequired,
};

PortalNav.NavButton = NavButton;
PortalNav.NavLink = NavLink;
PortalNav.NavOldLink = NavOldLink;

export default PortalNav;
